export * from './mb-occ-homepage-facets.adapter'
